import BlurView from "./BlurView";

export default BlurView;
